import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgDealDurationSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 3a.75.75 0 00-1.5 0v1.25H5A2.75 2.75 0 002.25 7v12A2.75 2.75 0 005 21.75h8.316a6 6 0 016.43-9.492v-1.181A.753.753 0 0019.75 11V7A2.75 2.75 0 0017 4.25h-1.25V3a.75.75 0 00-1.5 0v1.25h-6.5V3zm8 2.75h-1.5V7a.75.75 0 001.5 0V5.75zm-8 0h-1.5V7a.75.75 0 001.5 0V5.75zM18.25 10a.75.75 0 01-.75.75h-13a.75.75 0 010-1.5h13a.75.75 0 01.75.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.496a.75.75 0 00-1.5 0V18c0 .199.079.39.22.53l1 1a.75.75 0 101.06-1.06l-.78-.78v-1.194z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM14.75 18a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0z",
    fill: "currentColor"
  })));
}

export { SvgDealDurationSolid as ReactComponent };
